import { Head } from "@inertiajs/react";
import { BlankLayout } from "@/Logigate/components/layout/AuthLayout";
import type { Catalogo, CatalogoModulo } from "@/types/planos";
import WebsiteHeader from "./components/WebsiteHeader";
import HeroSection from "./components/HeroSection";
import AnnouncementBar from "./components/AnnouncementBar";
import FacturacaoElectronicaSection from "./components/FacturacaoElectronicaSection";
import SocialProofSection from "./components/SocialProofSection";
import LojaDoSite from "./components/LojaDoSite";
import PrestadoresSection from "./components/PrestadoresSection";
import PrestadoresComoFuncionaSection from "./components/PrestadoresComoFuncionaSection";
import ModulesShowcase from "./components/ModulesShowcase";
import ComoFuncionaSection from "./components/ComoFuncionaSection";
import EstabelecimentosSection from "./components/EstabelecimentosSection";
import POSSection from "./components/POSSection";
import IntegrationsSection from "./components/IntegrationsSection";
import AGTComplianceSection from "./components/AGTComplianceSection";
import FeaturesSection from "./components/FeaturesSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import WebsiteFooter from "./components/WebsiteFooter";

/** O módulo do site é o do catálogo (`CatalogoDePlanos::paraApp`). */
export type Modulo = CatalogoModulo;

export interface Stats {
    empresas: number;
    facturas: number;
    utilizadores: number;
    estabelecimentos: number;
}

interface Props {
    catalogo: Catalogo;
    /** O catálogo da conta de prestador de serviços (só combos). Opcional: a cache do site pode ainda não o trazer. */
    catalogo_prestador?: Catalogo | null;
    /** Os mesmos de `catalogo.modulos`; mantido para quem ainda o lê. */
    modulos: CatalogoModulo[];
    stats: Stats;
}

function WebsitePage({ catalogo, catalogo_prestador, stats }: Props) {
    const temPrestadores = (catalogo_prestador?.combos?.length ?? 0) > 0;

    return (
        <>
            <Head title="ERP de Gestão Empresarial | Logigate" />
            {/* `data-miolo-painel`: a varredura dos testes procura o miolo da página (aqui, o site todo). */}
            <div data-miolo-painel className="bg-white min-h-screen">
                <AnnouncementBar />
                <WebsiteHeader mostrarPrestadores={temPrestadores} />
                <HeroSection />
                <FacturacaoElectronicaSection />
                <SocialProofSection stats={stats} />
                <LojaDoSite catalogo={catalogo} temPrestadores={temPrestadores} />
                {temPrestadores && catalogo_prestador && (
                    <>
                        <PrestadoresSection catalogo={catalogo_prestador} hrefSaberMais="/prestadores" />
                        <PrestadoresComoFuncionaSection />
                    </>
                )}
                <ModulesShowcase modulos={catalogo.modulos} />
                <ComoFuncionaSection />
                <EstabelecimentosSection />
                <POSSection />
                <IntegrationsSection />
                <AGTComplianceSection />
                <FeaturesSection />
                <FAQSection />
                <CTASection />
                <WebsiteFooter mostrarPrestadores={temPrestadores} />
            </div>
        </>
    );
}

WebsitePage.layout = (page: any) => <BlankLayout>{page}</BlankLayout>;
export default WebsitePage;
